/** Basis-Pfad des Kundenportals (Build-Zeit). Muss mit DB-Feld portal_settings.portal_base_path übereinstimmen. */
function normalizePortalBase(raw: string | undefined): string {
  const r = (raw || '/portal').trim();
  const withSlash = r.startsWith('/') ? r : `/${r}`;
  const noTrail = withSlash.replace(/\/+$/, '');
  return noTrail || '/portal';
}

export const PORTAL_BASE = normalizePortalBase(import.meta.env.VITE_CUSTOMER_PORTAL_BASE);

/** Absoluter Pfad unterhalb von PORTAL_BASE, z. B. portalPath('/tickets') → '/portal/tickets' */
export function portalPath(relative: string): string {
  const rel = relative.startsWith('/') ? relative : `/${relative}`;
  if (rel === '/') return PORTAL_BASE;
  return `${PORTAL_BASE}${rel}`;
}

export function isPortalLoginPath(pathname: string): boolean {
  return pathname === `${PORTAL_BASE}/login`;
}
